import { render } from "./StockDetails.vue?vue&type=template&id=d181aa8e&scoped=true&ts=true"
import script from "./StockDetails.vue?vue&type=script&lang=ts"
export * from "./StockDetails.vue?vue&type=script&lang=ts"

import "./StockDetails.vue?vue&type=style&index=0&id=d181aa8e&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d181aa8e"]])

export default __exports__